<template>
  <!-- 节假日新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增节假日'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 节假日名称（必填） -->
          <a-form-item label="节假日名称" name="name">
            <a-input v-model:value="form.name" placeholder="请输入节假日名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 开始时间（必填） -->
          <a-form-item label="开始时间" name="startTime">
            <a-date-picker
              v-model:value="form.startTime"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择开始时间"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 结束时间（必填） -->
          <a-form-item label="结束时间" name="endTime">
            <a-date-picker
              v-model:value="form.endTime"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择结束时间"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 天数（必填） -->
          <a-form-item label="天数" name="holidayDays">
            <a-input-number
              v-model:value="form.holidayDays"
              :min="0"
              :step="1"
              style="width: 100%"
              placeholder="请输入天数"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { getHoliday, addHoliday, updateHoliday } from '@/api/system/holiday'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        companyId: null,

        projectId: null,

        name: null,

        startTime: null,

        endTime: null,

        holidayDays: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '请输入节假日名称', trigger: 'blur' },
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' },
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          {
            validator: (rule, value, callback) =>
              this.validateEndTime(rule, value, callback),
            trigger: 'change',
          },
        ],
        holidayDays: [
          { required: true, message: '请输入天数', trigger: 'change' },
        ],
      },
    }
  },
  created() {},
  computed: {},
  watch: {
    'form.startTime'() {
      this.updateHolidayDays()
    },
    'form.endTime'() {
      this.updateHolidayDays()
    },
  },
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        companyId: null,
        projectId: null,
        name: null,
        startTime: null,
        endTime: null,
        holidayDays: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /**
     * 校验结束时间必须晚于开始时间
     */
    validateEndTime(rule, value, callback) {
      if (!value || !this.form.startTime) {
        callback()
        return
      }
      const end = new Date(value)
      const start = new Date(this.form.startTime)
      if (end <= start) {
        callback(new Error('结束时间必须晚于开始时间'))
      } else {
        callback()
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      // 新增时不需要设置项目ID
      this.form.projectId = null
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHoliday({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm() {
      // 表单验证
      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        // 判断是修改还是新增
        if (this.form.id !== undefined && this.form.id !== null) {
          // 修改操作
          updateHoliday(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          // 新增操作 - 不传项目ID
          const submitForm = { ...this.form }
          // 确保不传项目ID
          delete submitForm.projectId
          addHoliday(submitForm)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      }).catch(() => {
        // 验证失败
        return false
      })
    },
    /**
     * 根据开始/结束时间自动计算天数
     */
    updateHolidayDays() {
      const { startTime, endTime } = this.form
      if (!startTime || !endTime) {
        return
      }
      const start = new Date(startTime)
      const end = new Date(endTime)
      if (isNaN(start.getTime()) || isNaN(end.getTime()) || end <= start) {
        return
      }
      const diffMs = end.getTime() - start.getTime()
      const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
      this.form.holidayDays = days
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 90px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
